import PickupLogisticsCard from "./PickupLogisticsCard";
import PickupLogisticsDetails from "./PickupLogisticsDetails";
import "./pickup_logistics.css";

export default {
  id: "viriyah_pickup_logistics_2p3p",
  company: "วิริยะประกันภัย",
  productLine: "motor",
  categories: ["pickup"],
  nameTH: "รหัส 320 Logistics 2+ / 3+",
  description: "รถบรรทุก ≤4 ตัน สำหรับ Logistics และคอก/ตู้บรรทุกสินค้า",
  accent: "#1e40af",
  expiresAt: "2024-12-31",
  card: PickupLogisticsCard,
  detail: PickupLogisticsDetails,
  active: true,
};
